/**
 * TC dashboard periods (TC-DASHBOARD-V2-DESIGN §3). Dates are local calendar dates as 'YYYY-MM-DD'
 * (never toISOString — that shifts the day in the UAE).
 */

export const PERIODS = [
  { key: 'today', label: 'Today' },
  { key: '7d', label: '7 days' },
  { key: 'month', label: 'This month' },
  { key: 'lastMonth', label: 'Last month' },
  { key: 'custom', label: 'Custom' },
];

const pad = (n) => String(n).padStart(2, '0');
export const toIso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const parse = (iso) => { const [y, m, d] = iso.split('-').map(Number); return new Date(y, m - 1, d); };
const addDays = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
const lastOfMonth = (y, m) => new Date(y, m + 1, 0);

// key → { from, to }; null when a custom range is incomplete or reversed
export const periodRange = (key, today = new Date(), custom = {}) => {
  const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  switch (key) {
    case 'today': return { from: toIso(t), to: toIso(t) };
    case '7d': return { from: toIso(addDays(t, -6)), to: toIso(t) };
    case 'month': return { from: toIso(new Date(t.getFullYear(), t.getMonth(), 1)), to: toIso(t) };
    case 'lastMonth': {
      const first = new Date(t.getFullYear(), t.getMonth() - 1, 1);
      return { from: toIso(first), to: toIso(lastOfMonth(first.getFullYear(), first.getMonth())) };
    }
    case 'custom': {
      const { from, to } = custom || {};
      if (!from || !to || from > to) return null;
      return { from, to };
    }
    default: return null;
  }
};

// The equal period right before: a whole calendar month → the whole previous month; otherwise the same number of
// days ending the day before `from`.
export const previousRange = ({ from, to }) => {
  const f = parse(from);
  const t = parse(to);
  const wholeMonth = f.getDate() === 1 && toIso(t) === toIso(lastOfMonth(f.getFullYear(), f.getMonth()));
  if (wholeMonth) {
    const prev = new Date(f.getFullYear(), f.getMonth() - 1, 1);
    return { from: toIso(prev), to: toIso(lastOfMonth(prev.getFullYear(), prev.getMonth())) };
  }
  const days = Math.round((t - f) / 86400000) + 1;
  const end = addDays(f, -1);
  return { from: toIso(addDays(end, -(days - 1))), to: toIso(end) };
};
